// istanbul ignore file

import * as yup from '@cld/yup-extra';

export enum SyntaxList {
  URL = 'url',
  ABAP = 'abap',
  ACTIONSCRIPT = 'actionscript',
  ADA = 'ada',
  APACHECONF = 'apacheconf',
  APL = 'apl',
  APPLESCRIPT = 'applescript',
  ARDUINO = 'arduino',
  ARFF = 'arff',
  ASCIIDOC = 'asciidoc',
  ASM6502 = 'asm6502',
  ASPNET = 'aspnet',
  AUTOHOTKEY = 'autohotkey',
  AUTOIT = 'autoit',
  BASH = 'bash',
  BASIC = 'basic',
  BATCH = 'batch',
  BISON = 'bison',
  BRAINFUCK = 'brainfuck',
  BRO = 'bro',
  C = 'c',
  CLIKE = 'clike',
  CLOJURE = 'clojure',
  COFFEESCRIPT = 'coffeescript',
  CPP = 'cpp',
  CRYSTAL = 'crystal',
  CSHARP = 'csharp',
  CSP = 'csp',
  CSSEXTRAS = 'cssExtras',
  CSS = 'css',
  D = 'd',
  DART = 'dart',
  DIFF = 'diff',
  DJANGO = 'django',
  DOCKER = 'docker',
  EIFFEL = 'eiffel',
  ELIXIR = 'elixir',
  ELM = 'elm',
  ERB = 'erb',
  ERLANG = 'erlang',
  FLOW = 'flow',
  FORTRAN = 'fortran',
  FSHARP = 'fsharp',
  GEDCOM = 'gedcom',
  GHERKIN = 'gherkin',
  GIT = 'git',
  GLSL = 'glsl',
  GO = 'go',
  GRAPHQL = 'graphql',
  GROOVY = 'groovy',
  HAML = 'haml',
  HANDLEBARS = 'handlebars',
  HASKELL = 'haskell',
  HAXE = 'haxe',
  HPKP = 'hpkp',
  HSTS = 'hsts',
  HTTP = 'http',
  ICHIGOJAM = 'ichigojam',
  ICON = 'icon',
  INFORM7 = 'inform7',
  INI = 'ini',
  IO = 'io',
  J = 'j',
  JAVA = 'java',
  JAVASCRIPT = 'javascript',
  JOLIE = 'jolie',
  JSON = 'json',
  JSX = 'jsx',
  JULIA = 'julia',
  KEYMAN = 'keyman',
  KOTLIN = 'kotlin',
  LATEX = 'latex',
  LESS = 'less',
  LIQUID = 'liquid',
  LISP = 'lisp',
  LIVESCRIPT = 'livescript',
  LOLCODE = 'lolcode',
  LUA = 'lua',
  MAKEFILE = 'makefile',
  MARKDOWN = 'markdown',
  MARKUPTEMPLATING = 'markupTemplating',
  MARKUP = 'markup',
  MATLAB = 'matlab',
  MEL = 'mel',
  MIZAR = 'mizar',
  MONKEY = 'monkey',
  N4JS = 'n4js',
  NASM = 'nasm',
  NGINX = 'nginx',
  NIM = 'nim',
  NIX = 'nix',
  NSIS = 'nsis',
  OBJECTIVEC = 'objectivec',
  OCAML = 'ocaml',
  OPENCL = 'opencl',
  OZ = 'oz',
  PARIGP = 'parigp',
  PARSER = 'parser',
  PASCAL = 'pascal',
  PERL = 'perl',
  PHPEXTRAS = 'phpExtras',
  PHP = 'php',
  PLSQL = 'plsql',
  POWERSHELL = 'powershell',
  PROCESSING = 'processing',
  PROLOG = 'prolog',
  PROPERTIES = 'properties',
  PROTOBUF = 'protobuf',
  PUG = 'pug',
  PUPPET = 'puppet',
  PURE = 'pure',
  PYTHON = 'python',
  Q = 'q',
  QORE = 'qore',
  R = 'r',
  REASON = 'reason',
  RENPY = 'renpy',
  REST = 'rest',
  RIP = 'rip',
  ROBOCONF = 'roboconf',
  RUBY = 'ruby',
  RUST = 'rust',
  SAS = 'sas',
  SASS = 'sass',
  SCALA = 'scala',
  SCHEME = 'scheme',
  SCSS = 'scss',
  SMALLTALK = 'smalltalk',
  SMARTY = 'smarty',
  SOY = 'soy',
  SQL = 'sql',
  STYLUS = 'stylus',
  SWIFT = 'swift',
  TCL = 'tcl',
  TEXTILE = 'textile',
  TSX = 'tsx',
  TWIG = 'twig',
  TYPESCRIPT = 'typescript',
  VBNET = 'vbnet',
  VELOCITY = 'velocity',
  VERILOG = 'verilog',
  VHDL = 'vhdl',
  VIM = 'vim',
  VISUALBASIC = 'visualBasic',
  WASM = 'wasm',
  WIKI = 'wiki',
  XEORA = 'xeora',
  XOJO = 'xojo',
  YAML = 'yaml',
}

export const cookbookRecipeSnippetDtoSchema = yup
  .object({
    assetUrl: yup.string().required(),
    language: yup.string().required(),
    snippet: yup.string().required(),
    syntax: yup.mixed<SyntaxList>().oneOf(Object.values(SyntaxList)),
  })
  .required();

export type CookbookRecipeSnippetDto = yup.InferType<typeof cookbookRecipeSnippetDtoSchema>;
